<template>
  <v-app>     
    <v-layout>
      <Navbar />      
      <v-content>       
        <About />        
        <Feature />
        <Footer />  
      </v-content>
      <RightNavbar />  
    </v-layout>
  </v-app>
</template>

<script>
  import Navbar from '@/components/shop/navbar/Navbar'
  import RightNavbar from '@/components/shop/navbar/RightNavbar'
  import About from '@/components/shop/sections/About'  
  import Feature from  '@/components/shop/sections/Feature'
  import Footer from  '@/components/shop/sections/Footer'  
  import db from '@/firebase/init'
  import moment from 'moment'
  export default {
    name:'Home',
    metaInfo: {    
      title: 'Elatukku', 
      meta: [
        {content: 'text/html; charset=utf-8'},
        {name: 'viewport', content: 'width=device-width, initial-scale=1'},
        {name: 'description', content: 'Complete Grocery E-Commerce with Business Management Software.'}
      ]
    },
    components:{
    Navbar,RightNavbar,About,Feature,Footer
    },
    data(){
      return{
      
      }
    },
    created(){

    }
  }
</script>

<style>

   
</style>



// WEBPACK FOOTER //
// src/components/shop/pages/About.vue